const C = process.env.REACT_APP_CLOUDINARY_BASE;

export const projects = [
  {
    id: 1,
    title: "Veena Shivakumar Residence",
    location: "Singapura Village, Holenarsipura, Hassan",
    image: `${C}/e1.jpg`,
    images: [`${C}/e1.jpg`, `${C}/e12.jpg`, `${C}/e13.jpg`, `${C}/e2.jpg`, `${C}/e18.jpg`, `${C}/e22.jpg`, `${C}/e4.jpg`, `${C}/e5.jpg`, `${C}/e8.jpg`, `${C}/veena_shivakumar.jpg`, `${C}/e10.jpg`, `${C}/e16.jpg`, `${C}/e17.jpg`,`${C}/e19.jpg`, `${C}/e21.jpg`, `${C}/e23.jpg`],
    category: "Villa",
    area: "6,000 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Villa with Pitched Roof architectural elevation. G+1+Terrace floor design with 2 bedrooms on each floor, double height cutout, triple height cutouts, and library. Features car parking, entry verandah, living room, pooja room, kitchen, dining, utility, and lift.",
    features: ["Pitched Roof Design", "G+1+Terrace", "Double & Triple Height Cutouts", "4 Bedrooms", "4 Attached Toilets", "Lift Provision", "Library", "Solar Platform"]
  },
  {
    id: 2,
    title: "Thilak Mamatha Residence",
    location: "Channapatana, Hassan",
    image: `${C}/thilak_mamatha.jpg`,
    images: [`${C}/thilak_mamatha.jpg`, `${C}/dsc06817.jpg`, `${C}/m20.jpg`, `${C}/dsc06780.jpg`, `${C}/dsc06796.jpg`, `${C}/m17.jpg`, `${C}/m19.jpg`, `${C}/m7.jpg`],
    category: "Villa",
    area: "6,000 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Villa with Flat Roof concept and modern architectural elevation. G+1+Terrace floor design featuring double height cutout, gym area, and library.",
    features: ["Flat Roof Design", "G+1+Terrace", "Modern Architecture", "4 Bedrooms", "Attached Toilets", "Gym Area", "Library", "Lift Provision"]
  },
  {
    id: 3,
    title: "Bore Gowda Residence",
    location: "Singapura, Holenarasipura, Hassan",
    image: `${C}/bs1.jpg`,
    images: [`${C}/bs1.jpg`, `${C}/bs10.jpg`, `${C}/bs12.jpg`, `${C}/bs13.jpg`, `${C}/bs14.jpg`, `${C}/bs2.jpg`, `${C}/bs3.jpg`, `${C}/bs5.jpg`, `${C}/bs6.jpg`, `${C}/bs7.jpg`, `${C}/bs9.jpg`, `${C}/bore_gowda.jpg`],
    category: "Villa",
    area: "6,500 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Villa with Pitched Roof concept and modern architectural elevation. G+1+Terrace floor design with double height cutout, triple height cutouts, and library.",
    features: ["Pitched Roof Design", "G+1+Terrace", "Modern Architecture", "4 Bedrooms", "4 Attached Toilets", "Double & Triple Height Cutouts", "Library", "Lift & Solar Platform"]
  },
  {
    id: 4,
    title: "Vijaya Vishaka Pillai Residence",
    location: "Ashwa Samudra Layout, Medhalli, Bangalore",
    image: `${C}/vijaya_pillai.jpg`,
    images: [`${C}/vijaya_pillai.jpg`],
    category: "Villa",
    area: "4,800 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Villa with Pitched Roof architectural elevation. G+2+Terrace floor design with 2 bedrooms on ground floor, 2 bedrooms on first floor, and 1 bedroom on terrace floor.",
    features: ["Pitched Roof Design", "G+2+Terrace", "5 Bedrooms", "5 Toilets", "Living & Dining", "Pooja Room", "Lift Provision", "Terrace Bedroom"]
  },
  {
    id: 5,
    title: "Sujatha T. D Rental Property",
    location: "Ashok Nagar, Tumkur",
    image: `${C}/sujatha_td.jpg`,
    images: [`${C}/sujatha_td.jpg`],
    category: "Commercial Building",
    area: "3,400 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Rental House with flat roof concept. G+1+Terrace floor design with 2 BHK rental house on ground floor and 3 bedrooms on first floor with attached toilets.",
    features: ["Flat Roof Design", "G+1+Terrace", "2 BHK Rental Unit", "3 Bedrooms", "Attached Toilets", "Utility Area", "Landscaping", "Solar Platform"]
  },
  {
    id: 6,
    title: "Pushpa Pradeep Residence & Commercial",
    location: "Kumbalgodu, Bangalore",
    image: `${C}/pushpa_pradeep.jpg`,
    images: [`${C}/pushpa_pradeep.jpg`],
    category: "Live-Work Space",
    area: "6,000 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Villa with Commercial office space. G+2+Terrace floor design with 1 BHK on ground floor + 2 commercial shops, 3 bedrooms on first floor, and 1 bedroom on second floor with double height living room.",
    features: ["Mixed Use Design", "G+2+Terrace", "2 Commercial Shops", "1 BHK Rental Unit", "4 Bedrooms", "Double Height Living", "Balconies", "Solar Platform"]
  },
  {
    id: 7,
    title: "Pradeep S M Villa",
    location: "Singapura, Bangalore",
    image: `${C}/p3.jpg`,
    images: [`${C}/p3.jpg`, `${C}/p4.jpg`, `${C}/p10.jpg`, `${C}/p5.jpg`, `${C}/p5.3.jpg`, `${C}/p6.jpg`, `${C}/p7.jpg`, `${C}/p9.jpg`],
    category: "Villa",
    area: "2,500 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Villa with combination of flat and pitched roof and double height architectural elevation. G+1+Terrace floor design with 3 BHK house.",
    features: ["Pitched & Flat Roof", "G+1+Terrace", "3 BHK House", "Car Parking", "Double Height Elevation", "Staircase", "Solar Platform", "Overhead Tank"]
  },
  {
    id: 8,
    title: "Renuka Divakar Villa",
    location: "Singapura, Bangalore",
    image: `${C}/renuka_divakar.jpg`,
    images: [`${C}/renuka_divakar.jpg`],
    category: "Villa",
    area: "2,500 sq ft",
    year: "2024",
    status: "completed",
    description: "Construction of Residential Villa with combination of flat and pitched roof and double height architectural elevation. G+1+Terrace floor design with 3 BHK house.",
    features: ["Pitched & Flat Roof", "G+1+Terrace", "3 BHK House", "Car Parking", "Double Height Elevation", "Staircase", "Solar Platform", "Overhead Tank"]
  },
  {
    id: 9,
    title: "Kishore Residence",
    location: "Hassan",
    image: `${C}/dsc07052.jpg`,
    images: [`${C}/dsc07052.jpg`, `${C}/dsc07066.jpg`, `${C}/ps1.jpg`, `${C}/ps10.jpg`, `${C}/ps10.1.jpg`, `${C}/ps10.2.jpg`, `${C}/ps11.jpg`, `${C}/ps15.jpg`, `${C}/ps16.jpg`, `${C}/ps17.jpg`, `${C}/ps18.jpg`, `${C}/ps19.jpg`, `${C}/ps6.jpg`, `${C}/ps6.1.jpg`, `${C}/ps7.jpg`, `${C}/ps9.jpg`, `${C}/kishore.jpg`],
    category: "Villa",
    area: "6,000 sq ft",
    year: "2025",
    status: "completed",
    description: "Construction of Residential Villa @ Chandra layout Site Number 893, Bangalore-560040. Plot Area of the Site - 30 Feet * 40 Feet. Built Up Area 6,000 sq ft. Villa Having the G+2+Terrace Floor Residential Villa with Commercial office space Ground Floor + 1 BHK house in First Floor. The House is Designed on the flat roof and Commercial Building.",
    features: ["Plot 30x40 Feet", "6000 Sq Ft Built Up", "G+2+Terrace", "Flat Roof Design", "Commercial Office Space", "Car Parking", "2 BHK + 3 Bedrooms", "Double Height Living", "Balconies", "Solar Platform", "Overhead Tank"]
  },
  {
    id: 10,
    title: "Abhishek Eswar Residence",
    location: "Chandra Layout, Bangalore",
    image: `${C}/abhishek_eswar.jpg`,
    images: [`${C}/abhishek_eswar.jpg`],
    category: "Villa",
    area: "5,500 sq ft",
    year: "2025",
    status: "ongoing",
    description: "Construction of Residential Villa with flat roof concept and modern architectural elevation. G+4+Terrace floor design with 1 BHK rental on ground floor, multiple bedrooms across floors, home theater, multipurpose hall, covered garden, and water fountain.",
    features: ["Flat Roof Design", "G+4+Terrace", "7 Bedrooms", "Home Theater", "Multipurpose Hall", "Covered Garden", "Water Fountain", "Open Sky Light Terrace"]
  },
  {
    id: 11,
    title: "Kiran Gowda Appaji Villa",
    location: "Satya Mangala, Hassan",
    image: `${C}/kiran_gowda.jpg`,
    images: [`${C}/kiran_gowda.jpg`],
    category: "Villa",
    area: "2,400 sq ft",
    year: "2025",
    status: "ongoing",
    description: "Construction of Residential Villa with flat roof concept and modern architectural elevation. G+1+Terrace with spacious living room, 1 bedroom on ground floor, and 2 bedrooms on first floor with terrace garden.",
    features: ["Flat Roof Design", "G+1+Terrace", "3 Bedrooms", "Living & Dining", "Pooja Room", "Terrace Garden", "Utility", "Landscaping"]
  },
  {
    id: 12,
    title: "Chandre Gowda S R Villa",
    location: "Singapura, Hassan",
    image: `${C}/chandre_gowda.jpg`,
    images: [`${C}/chandre_gowda.jpg`],
    category: "Villa",
    area: "3,600 sq ft",
    year: "2025",
    status: "ongoing",
    description: "Construction of Residential Villa with flat roof concept, modern architectural elevation, and random stone cladding. G+1+Terrace with 2 bedrooms on each floor, double height living room, and terrace.",
    features: ["Flat Roof Design", "G+1+Terrace", "Stone Cladding", "4 Bedrooms", "Double Height Living", "Terrace", "Utility", "Landscaping"]
  },
  {
    id: 13,
    title: "Gowtham S V Villa",
    location: "Hassan",
    image: `${C}/gowtham_sv.jpg`,
    images: [`${C}/gowtham_sv.jpg`],
    category: "Villa",
    area: "2,500 sq ft",
    year: "2025",
    status: "ongoing",
    description: "Construction of Residential Villa with pitched roof concept and modern architectural elevation. G+1+Terrace with 2 bedrooms on ground floor and terrace garden on first floor.",
    features: ["Pitched Roof Design", "G+1+Terrace", "2 Bedrooms", "Living & Dining", "Pooja Room", "Terrace Garden", "Utility", "Landscaping"]
  },
  {
    id: 14,
    title: "Sombhe Gowda Villa",
    location: "Singapura, Hassan",
    image: `${C}/sombhe_gowda.jpg`,
    images: [`${C}/sombhe_gowda.jpg`],
    category: "Villa",
    area: "5,600 sq ft",
    year: "2025",
    status: "upcoming",
    description: "Construction of Contemporary Villa with modern architectural elevation and pitched roof. G+1+Terrace with spacious parks, jacuzzi, home theatre, bar counter, bonfire area, and 4 bedrooms.",
    features: ["Contemporary Design", "Pitched Roof", "G+1+Terrace", "4 Bedrooms", "Home Theatre", "Bar Counter", "Jacuzzi", "Bonfire & Parks"]
  },
  {
    id: 15,
    title: "Raju Residence & Commercial",
    location: "Hassan",
    image: `${C}/lm1.jpg`,
    images: [`${C}/lm1.jpg`, `${C}/lm12.jpg`, `${C}/lm13.jpg`, `${C}/lm14.jpg`, `${C}/lm15.jpg`, `${C}/lm18.jpg`, `${C}/lm4.jpg`, `${C}/lm5.jpg`, `${C}/lm7.jpg`, `${C}/lm9.jpg`],
    category: "Live-Work Space",
    area: "4,000 sq ft",
    year: "2025",
    status: "completed",
    description: "Construction of Residential Villa with contemporary architectural elevation and premium quality construction. G+1+Terrace floor design with modern amenities and spacious interiors.",
    features: ["Contemporary Design", "G+1+Terrace", "4 Bedrooms", "Living & Dining", "Pooja Room", "Modern Kitchen", "Car Parking", "Landscaping"]
  }
];

export const featuredProjects = [
  {
    image: `${C}/e1.jpg`,
    title: "Veena Shivakumar Villa",
    location: "Holenarsipura, Hassan"
  },
  {
    image: `${C}/vijaya_pillai.jpg`,
    title: "Vijaya Pillai Residence",
    location: "Ashwa Samudra, Bangalore"
  },
  {
    image: `${C}/sujatha_td.jpg`,
    title: "Sujatha T.D Rental Property",
    location: "Ashok Nagar, Tumkur"
  }
];
